var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"lavContainer",staticClass:"atom-lottie-animation",style:({
    width: this.width ? `${this.width}px` : '100%',
    height: this.height ? `${this.height}px` : '100%'
  })})
}
var staticRenderFns = []

export { render, staticRenderFns }